import { api } from './api-base';
import { Comment } from '../types';

export interface CommentsResponse {
  data: Comment[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

// Comments API
export const commentsApi = {
  // Get comments with filtering
  getComments: async (params?: {
    page?: number;
    limit?: number;
    topicId?: string;
    parentId?: string | null;
    sortBy?: 'recent' | 'oldest' | 'popular';
  }): Promise<CommentsResponse> => {
    const response = await api.get('/comments', { params });
    return response.data;
  },

  // Get single comment
  getComment: async (id: string): Promise<Comment> => {
    const response = await api.get(`/comments/${id}`);
    return response.data;
  },

  // Create new comment
  createComment: async (commentData: {
    content: string;
    topicId: string;
    parentId?: string;
    latitude?: number;
    longitude?: number;
    country?: string | null;
    region?: string | null;
    city?: string | null;
    locationLabel?: string | null;
    locationFullLabel?: string | null;
    isAnonymous?: boolean;
  }): Promise<Comment> => {
    const response = await api.post('/comments', commentData);
    return response.data;
  },

  // Update comment
  updateComment: async (id: string, commentData: {
    content?: string;
    latitude?: number;
    longitude?: number;
    country?: string | null;
    region?: string | null;
    city?: string | null;
    locationLabel?: string | null;
    locationFullLabel?: string | null;
  }): Promise<Comment> => {
    const response = await api.put(`/comments/${id}`, commentData);
    return response.data;
  },

  // Delete comment
  deleteComment: async (id: string): Promise<void> => {
    await api.delete(`/comments/${id}`);
  },

  // Moderator delete comment (hard delete with moderation record)
  moderatorDeleteComment: async (id: string, reason?: string): Promise<void> => {
    await api.delete(`/admin/comments/${id}`, { 
      params: { 
        reason: reason || undefined
      }
    });
  },

  // Vote on comment
  voteComment: async (id: string, voteType: 'UPVOTE' | 'DOWNVOTE'): Promise<Comment> => {
    const response = await api.post(`/comments/${id}/vote`, { voteType });
    return response.data;
  },
};
